import React from 'react';
import { TLoaderType } from 'types';
import classNames from 'classnames';
import style from './LoaderWithProps.module.scss';

interface ILoaderWithProps {
	loaderSize: TLoaderType;
}

const LoaderWithProps: React.FC<ILoaderWithProps> = ({ loaderSize }) => {
	const containerClasses = classNames(style.container, {
		[style.smallSpinner]: loaderSize === 'small',
		[style.avatarSpinner]: loaderSize === 'avatar',
	});

	return (
		<div className={containerClasses} data-test="LoaderWithProps">
			<div className={style.spinner}>
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};

export default LoaderWithProps;
